import { Observable } from "rxjs";

export abstract class RechargeWalletService {
  /**
   * Recharges the wallet with the specified amount.
   * 
   * @param amount - The amount to recharge the wallet.
   * @returns Observable that emits a URL string to open a payment gateway.
   */
  abstract apply(amount: number): Observable<string>;
}
